import { css } from "@emotion/react";
import useIsPC from "./hooks/useIsPC";
import HumburgerMenu from "./components/molecules/ScheduleHumburgerMenu";

const SchedulePage = () => {
  const isPC = useIsPC();

  return (
    <div css={mainStyle}>
      {!isPC && <HumburgerMenu />}
      <div css={titleMainStyle}>
        <img
          src={
            process.env.REACT_APP_ASSET_BASE_PATH + "/img/home-ashi-girl.png"
          }
          alt="音楽朗読劇 アシガール"
          css={homeImgStyle}
        />
      </div>
      <div css={titleListWrapperStyle}>キャスト出演スケジュール</div>
      {isPC ? (
        <img
          src={
            process.env.REACT_APP_ASSET_BASE_PATH + "/img/cast-schedule-pc.png"
          }
          alt="キャスト出演スケジュール"
          css={scheduleImgStyle}
        />
      ) : (
        <>
          <img
            id="cast-schedule-0805"
            src={
              process.env.REACT_APP_ASSET_BASE_PATH +
              "/img/cast-schedule-0805.png"
            }
            alt="キャスト出演スケジュール"
            css={scheduleImgStyle}
          />
          <img
            id="cast-schedule-0806-1230"
            src={
              process.env.REACT_APP_ASSET_BASE_PATH +
              "/img/cast-schedule-0806-1230.png"
            }
            alt="キャスト出演スケジュール"
            css={scheduleImgStyle}
          />
          <img
            id="cast-schedule-0806-1800"
            src={
              process.env.REACT_APP_ASSET_BASE_PATH +
              "/img/cast-schedule-0806-1800.png"
            }
            alt="キャスト出演スケジュール"
            css={scheduleImgStyle}
          />
        </>
      )}
    </div>
  );
};

const primaryColor = "#DD6B74";

const mainStyle = css`
  width: 100%;
`;

const titleMainStyle = css`
  padding: 20px 0 10px;
  display: flex;
  justify-content: center;
`;

const homeImgStyle = css`
  width: 270px;
`;

const titleListWrapperStyle = css`
  width: 100%;
  padding: 3px 0;
  font-size: 8px;
  font-weight: bold;
  color: #fff;
  background-color: ${primaryColor};
`;

const scheduleImgStyle = css`
  margin-top: 30px;
  width: 300px;
  @media (min-width: 768px) {
    margin-top: 10px;
    width: 80%;
    max-width: 1100px;
  }
`;

export default SchedulePage;
